import { providePrimeNG } from 'primeng/config';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import localeNl from '@angular/common/locales/nl';
import { registerLocaleData } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HttpClient, withInterceptors, provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';

import { MessageService } from 'primeng/api';
import { NamedRouterModule } from '@/app/core/services/named-router';

import { SvgIconModule } from '@/app/shared/components/ui/svg-icon';

import { AppRoutes } from '@/app/core/routes';
import { apiInterceptor } from '@/app/core/interceptors/api.interceptor';
import { authInterceptor, refreshInterceptor } from '@/app/core/interceptors';

registerLocaleData(localeNl);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    providePrimeNG(),
    provideHttpClient(withInterceptors([apiInterceptor, authInterceptor, refreshInterceptor])),
    importProvidersFrom(
      SvgIconModule.forRoot({
        spriteUrl: '/assets/icons/sprite.svg',
      }),
      NamedRouterModule.forRoot(AppRoutes),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      GoogleMapsModule,
    ),
  ],
};
